import { api } from "@/lib/api";

export const visitsApi = {
  verify: (member_code) =>
    api.post("/visits/verify", { member_code }).then((r) => r.data),

  search: (q) =>
    api.post("/visits/search", { q }).then((r) => r.data),

  log: (payload) =>
    api.post("/visits/log", payload).then((r) => r.data),

  listProviderVisits: (params = {}) =>
    api.get("/visits", { params }).then((r) => r.data),

  myHistory: (params = {}) =>
    api.get("/members/me/visits", { params }).then((r) => r.data),
};
